export enum EDemandControlRequestType {
  DEMAND_CONTROL_LIMIT = "DEMAND_CONTROL_LIMIT",
  POWER_REDUCTION = "POWER_REDUCTION",
}
